import * as QuestionListActions from './question-list.actions';

import { Question } from '../../shared/question.model';

export interface State {
  questions: Question[];
  editedQuestion: Question;
  editedQuestionIndex: number;
}

const initialState: State = {
  questions: [
    new Question('id1001', 'First Question', 'How are you?' , 'TextInput' , 0 , 0 , false),
    new Question('id1002', 'Second Question', 'How are you doing?' , 'TextInput', 0, 0, false ),
  ],
  editedQuestion: null,
  editedQuestionIndex: -1
};

export function questionListReducer(state = initialState, action: QuestionListActions.QuestionListActions) {
  switch (action.type) {
    case QuestionListActions.ADD_QUESTION:
      return {
        ...state,
        questions: [...state.questions, action.payload]
      };
    case QuestionListActions.ADD_QUESTIONS:
      return {
        ...state,
        questions: [...state.questions, ...action.payload]
      };
    case QuestionListActions.UPDATE_QUESTION:
      const question = state.questions[state.editedQuestionIndex];
      const updatedQuestion = {
        ...question,
        ...action.payload.question
      };
      const questions = [...state.questions];
      questions[state.editedQuestionIndex] = updatedQuestion;
      return {
        ...state,
        questions: questions,
        editedIngredient: null,
        editedIngredientIndex: -1
      };
    case QuestionListActions.DELETE_QUESTION:
      const oldQuestions = [...state.questions];
      oldQuestions.splice(state.editedQuestionIndex, 1);
      return {
        ...state,
        questions: oldQuestions,
        editedQuestion: null,
        editedQuestionIndex: -1
      };
    case QuestionListActions.START_EDIT:
      const editedQuestion = {...state.questions[action.payload]};
      return {
        ...state,
        editedQuestion: editedQuestion,
        editedQuestionIndex: action.payload
      };
    case QuestionListActions.STOP_EDIT:
      return {
        ...state,
        editedQuestion: null,
        editedQuestionIndex: -1
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/question-list/store/question-list.reducers.ts